export default "/images/11f0a7307b58b43f3b889491bc270b12.avif";